import * as React from 'react';
import { forwardRef } from "react";
import { clsx } from 'clsx';
import IconFontAwesome from "./iconFontAwesome";

interface Props extends React.ComponentPropsWithRef<"button"> {
	children?: React.ReactNode,
	icon?: string,
	disabled?: boolean
}

const ButtonMenuItem = forwardRef<HTMLButtonElement, Props>(function(
	{
		children = null,
		className = '',
		disabled = false,
		icon = '',
		...otherProps
	}: Props,
	ref
) {
	if (otherProps && otherProps.hasOwnProperty('data-disabled')) {
		disabled = true;
	}

	return (<>
		<button
			className={clsx(
				"w-full text-left border-0 !bg-transparent p-2 rounded-md hover:!bg-primary-admin-200",
				"data-[disabled]:text-grey-400 data-[disabled]:!bg-transparent data-[disabled]:shadow-none data-[disabled]:cursor-not-allowed",
				className
			)}
			ref={ref}
			disabled={disabled}
			{...otherProps}
		>
			{icon && <IconFontAwesome className={clsx(icon, "mr-2", (disabled && "!text-grey-400"))}/>}
			{children}
		</button>
	</>);
});

export default ButtonMenuItem;
